import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class KitaBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'kitaMonthlyBudget',
      accessorFn: value => value.kitaOptions?.monthlyBudget,
      header: 'KITA.fields.monthlyBudget',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
  ];
}
